<template>
    <div class="notification-bar" :class="{ 'hide-mute-bar': hideMuteBar || hideMuteBarForSession, 'rooms-open': !isBreakoutRoomsHidden}">
        <div class="message-container">
            <div class="message">You are on mute</div>
            <div class="action-button" @click="unmuteUser">Unmute</div>
        </div>
        <div class="toggle-arrow" @click="hideMuteNotificationBar">
            <IconBase class="close-icon" :width="24" :height="24" :fill="'#FFFFFF'">
                <IconAngleDown />
            </IconBase>
        </div>
    </div>
</template>
  
<script>
import IconBase from "../IconBase.vue";
import IconAngleDown from "../icons/IconAngleDown";

import { mapState } from "vuex";

export default {
    props: ['jitsiApi'],
    name: "MuteNotification",
    components: {
        IconBase,
        IconAngleDown
    },
    data: function() {
        return {
            hideMuteBar: true,
            hideMuteBarForSession: false
        }
    },
    methods: {
        hideMuteNotificationBar() {
            this.hideMuteBar = true;
            this.hideBarCloseCount = Number(localStorage.getItem('hideBarCloseCount'));
            if(this.hideBarCloseCount && this.hideBarCloseCount >= 2) {
                this.hideMuteBarForSession = true;
            } else {
                this.hideBarCloseCount ? localStorage.setItem('hideBarCloseCount', ++this.hideBarCloseCount) : localStorage.setItem('hideBarCloseCount', 1);
            }
            this.$store.commit("rooms/setMuteBarVisibleStatus", !(this.hideMuteBar || this.hideMuteBarForSession));
        },
        unmuteUser() {
            this.jitsiApi.executeCommand("toggleAudio");
        }
    },
    mounted: function() {
        
    },
    watch: {
        isAudioMuted: function(newVal) {
            this.hideMuteBar = !newVal;
            this.$store.commit("rooms/setMuteBarVisibleStatus", !(this.hideMuteBar || this.hideMuteBarForSession));
        }
    },
    computed: {
        ...mapState({
            isAudioMuted: (state) => state.rooms.isAudioMuted,
            currentParticipant: state => state.rooms.currentParticipant,
            isBreakoutRoomsHidden: state => state.rooms.isBreakoutRoomsHidden,
        }),
    }
};
</script>
  
<style scoped>
.notification-bar {
    height: 46px;
    min-height: 46px;
    background: #762EE5;
    mix-blend-mode: normal;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 16px;
    visibility: visible;
    transition: all ease-in 0.3s;
}

.hide-mute-bar {
    height: 0;
    min-height: 0;
    visibility: hidden;
    transition: all ease-in 0.3s;
}

.message-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    justify-content: center;
}

.message {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #FFF;
    display: inline-block;
    padding-right: 10px;
}

.action-button {
    width: 72px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 8px;
    color: #762EE5;
    font-weight: 600;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    cursor: pointer;
}

.toggle-arrow {
    height: 24px;
    z-index: 12;
}

.close-icon {
    transform: rotate(180deg);
}

@media (max-width: 767px) {
    .message-container {
        justify-content: flex-start;
    }
    .rooms-open {
        width: calc(100vw - 267px);
        overflow: hidden;
        white-space: nowrap;
        box-sizing: border-box;
    }

    .toggle-arrow {
        z-index: 0;
    }
}
@media (hover: none) {
    .message-container {
        justify-content: flex-start;
    }

    .rooms-open {
        width: calc(100vw - 267px);
        overflow: hidden;
        white-space: nowrap;
        box-sizing: border-box;
    }

    .toggle-arrow {
        z-index: 0;
    }
}
</style>